export default __webpack_public_path__ + "static/allency-support-areas-management-5ad403fe150304a77add6791f9b63a6b.svg";